import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { ComputedPeriodDurationDto } from '../../../shared/modules/shared/dtos/computed-period-duration.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { RentalAgreementRecordCategoryEnum } from '../enums/rental-agreement-record-category.enum';
import { RentalAgreementStatusEnum } from '../enums/rental-agreement-status.enum';
import { RentalAgreementTypeEnum } from '../enums/rental-agreement-type.enum';

import { RentalAgreementLinksDto } from './rental-agreement-links.dto';

/**
 * Rental agreement DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.RENTAL_AGREEMENT)
export class RentalAgreementSearchDto extends BaseSearchDto {
	code!: string;
	documentNumber!: string;
	qrCode?: string | null;
	status!: RentalAgreementStatusEnum;
	recordCategory!: RentalAgreementRecordCategoryEnum;
	type!: RentalAgreementTypeEnum;
	vehicleVin?: string | null;
	vehicleCategoryName?: string | null;
	startsAt?: Date | null;
	endsAt?: Date | null;
	vehicleLicensePlate?: string | null;
	customerContactShortName?: string | null;
	agentContactShortName?: string | null;
	links?: RentalAgreementLinksDto | null;
	files?: FileDto[] | null;
	tags?: TagListDto[] | null;

	computedPeriod?: ComputedPeriodDurationDto | null;
	computedTotalGross?: number | null;
	computedCommissionNet?: number | null;
}
